import React from 'react';
import './mantencion-veh.css';

// Componentes
import { Tag } from 'primereact/tag';

// Iconos
import WaterDropIcon from "@mui/icons-material/WaterDrop";
import DeviceThermostatIcon from "@mui/icons-material/DeviceThermostat";
import ErrorIcon from "@mui/icons-material/Error";
import TripOriginIcon from "@mui/icons-material/TripOrigin";
import SpeedIcon from '@mui/icons-material/Speed';

const MantencionVeh = React.memo(({ vehiculo, mantencionesPrevias = {} }) => {
  if (!vehiculo) {
    return (
      <div className='p-1'>
        <div className="alert alert-primary" role="alert">
          <h5 className="alert-heading">Mantenimiento del Vehículo</h5>
          <p>
            En este apartado podrá encontrar el detalle de las fechas de los próximos mantenimientos del vehículo seleccionado, 
            junto al nombre del mantenimiento a realizar.
          </p>
        </div>
      </div>
    );
  }
  
  const kmActual = vehiculo.kmActual || 0;

return (
  <div className='p-1'>
    <div className="mantencion-km-banner">
      <div className="mantencion-icon-wrap kilometraje">
        <SpeedIcon className='icon' />
      </div>
      <div >
        <p className="km-label">Kilometraje actual registrado</p>
        <p className="km-value">{kmActual?.toLocaleString('es-CL')} 
          <small className="km-unit"> km</small>
        </p>
      </div>
    </div>

    <div className="mantencion-list">
      {MANTENCIONES.map(({ key, nombre, intervalo, icon }) => {
        const kmUltima  = mantencionesPrevias[key] ?? 0;
        const kmProxima = kmUltima + intervalo;
        const recorrido = kmActual - kmUltima;
        const pct       = Math.min(100, Math.round((recorrido / intervalo) * 100));
        const { label, severity } = getEstado(kmActual, kmProxima);

        return (
          <div key={key} className="mantencion-card">

            <div className="mantencion-card-header">
              <div className="mantencion-card-title">
                <div className={`mantencion-icon-wrap ${key}`}>
                  {(() => { const Icon = icon; return <Icon/>; })()}
                </div>
                <div>
                  <p className="mantencion-nombre">{nombre}</p>
                  <p className="mantencion-intervalo">Cada {intervalo.toLocaleString('es-CL')} km</p>
                </div>
              </div>
              <Tag value={label} severity={severity} className='mantencion-tag-estados'/>
            </div>

            <div className="mantencion-data">
              <div className="mantencion-stat">
                <p className="mantencion-stat-label">Última mantención</p>
                <p className="mantencion-stat-value">
                  {kmUltima > 0 ? `${kmUltima.toLocaleString('es-CL')} km` : 'Sin registro'}
                </p>
              </div>
              <div className="mantencion-stat">
                <p className="mantencion-stat-label">Próxima mantención</p>
                <p className={`mantencion-stat-value ${severity === 'danger' ? 'vencido' : ''}`}>
                  {kmProxima.toLocaleString('es-CL')} km
                </p>
              </div>
            </div>

            <div>
              <div className="mantencion-progress-labels">
                <span>{kmUltima.toLocaleString('es-CL')}</span>
                <span>{recorrido.toLocaleString('es-CL')} / {intervalo.toLocaleString('es-CL')} km</span>
                <span>{kmProxima.toLocaleString('es-CL')}</span>
              </div>
              <div className="mantencion-bar-bg">
                <div className={`mantencion-bar-fill ${severity}`} style={{ width: `${pct}%` }} />
              </div>
            </div>

          </div>
        );
      })}
    </div>

  </div>
);
});

export default MantencionVeh;

const MANTENCIONES = [
  { key: 'aceite',       nombre: 'Cambio de aceite', intervalo: 10000, icon: WaterDropIcon },
  { key: 'neumaticos',   nombre: 'Neumáticos',       intervalo: 40000, icon: TripOriginIcon },
  { key: 'refrigerante', nombre: 'Refrigerante',     intervalo: 20000, icon: DeviceThermostatIcon },
  { key: 'frenos',       nombre: 'Frenos',           intervalo: 15000, icon: ErrorIcon },
];

const getEstado = (kmActual, kmProxima) => {
  const restante = kmProxima - kmActual;
  if (restante <= 0)    return { label: 'Vencido',    severity: 'danger',  pct: 100  };
  if (restante <= 2000) return { label: 'Por vencer', severity: 'warning', pct: Math.min(99, ((kmProxima - restante) / kmProxima) * 100) };
  
  return { label: 'Vigente',     severity: 'success', pct: null };
};

// const getBarColor = (severity) => ({ success: '#639922', warning: '#BA7517', danger:  '#E24B4A', }[severity]);
